<template>
  <div class="loader-container">
    <div class="model-loader">
      <div class="cube is-spinning">
        <div
          v-for="(cube, index) in cubeFaces"
          :key="index"
          :class="`cube__face cube__face--${cube}`"
        ></div>
      </div>
      <div class="model-loader__text typo-tiny">
        {{ $t('general.model_loading') }}...
      </div>
    </div>
  </div>
</template>

<script setup>
const cubeFaces = ['front', 'back', 'right', 'left', 'top', 'bottom'];
</script>

<style scoped lang="scss">
@import '@/stylesheets/global';

.loader-container {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
}

.model-loader {
  height: rem(150);
  perspective: rem(150);
  text-align: center;
  width: rem(150);

  &__text {
    font-weight: 300;
    margin-top: bu(3);
  }
  .cube {
    height: rem(150);
    position: relative;
    transform-style: preserve-3d;
    transform: translateZ(-rem(75));
    width: rem(150);

    &.is-spinning {
      -moz-animation: spinCube 5s linear infinite;
      -ms-animation: spinCube 5s linear infinite;
      -o-animation: spinCube 5s linear infinite;
      -webkit-animation: spinCube 5s linear infinite;
      animation: spinCube 5s linear infinite;
    }
  }
}

@keyframes spinCube {
  from { transform: translateZ(-100px) rotateX(0deg) rotateY(0deg) }
  to { transform: translateZ(-100px) rotateX(360deg) rotateY(360deg) }
}

.cube__face {
  border: 2px solid map-get($background-color, default);
  color: $white;
  height: rem(150);
  line-height: rem(150);
  position: absolute;
  text-align: center;
  width: rem(150);

  &--front { transform: rotateY(0deg) translateZ(rem(75)) }
  &--right { transform: rotateY(90deg) translateZ(rem(75)) }
  &--back { transform: rotateY(180deg) translateZ(rem(75)) }
  &--left { transform: rotateY(-90deg) translateZ(rem(75)) }
  &--top { transform: rotateX(90deg) translateZ(rem(75)) }
  &--bottom { transform: rotateX(-90deg) translateZ(rem(75)) }
}
</style>
